import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    skeletonProductListing: {},
    skeletonProductListProductCard: {
        width: '100%',
        marginBottom: '50px',
        [theme.breakpoints.down('md')]: {
            marginBottom: '20px',
        },
        '& ul': {
            gap: spacing.medium,
        },
    },
    skeletonFilterAction: {
        '& span': {
            display: 'flex',
        },
        '& span .react-loading-skeleton': {
            height: '28px',
            width: '71px',
            [theme.breakpoints.up('sm')]: {
                height: '40px',
                width: '125px',
            },
        },
        '& span:first-child .react-loading-skeleton': {
            marginRight: spacing.medium,
        },
        '& span:nth-child(2) .react-loading-skeleton': {
            width: '108px',
            [theme.breakpoints.up('sm')]: {
                width: '156px',
            },
        },
    },
    skeletonListContainer: {
        '& ul li span': {
            display: 'flex',
        },
        '& ul li:nth-child(2) span .react-loading-skeleton': {
            [theme.breakpoints.down('md')]: {
                width: '138px',
            },
        },
        '& ul li span .react-loading-skeleton': {
            height: '48px',
            width: '163px',
            [theme.breakpoints.up('sm')]: {
                height: '56px',
                width: '180px',
            },
            [theme.breakpoints.between('sm', 'md')]: {
                height: '48px',
                width: '186px',
            },
        },
    },
    skeletonAdditional: {
        '& span .react-loading-skeleton': {
            height: '28px',
            width: '84%',
            [theme.breakpoints.up('sm')]: {
                height: '36px',
                width: '100%',
            },
        },
    },
    skeletonActionButtons: {
        '& span .react-loading-skeleton': {
            height: '44px',
            width: '300px',
            [theme.breakpoints.up('sm')]: {
                height: '56px',
            },
        },
    },
    resultsViewed: {
        minWidth: '626px',
        height: '36px',
    },
}));
export default useStyles;
